import {Col, Input, notification, Row, Spin} from 'antd';
import autobind from 'autobind-decorator';
import * as React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {connect} from 'redux-scaffolding-ts';
import {withIdentity} from 'src/core/services/authentication';
import {formatMessage} from 'src/core/services/http.service';
import {ItemState, Query} from 'src/core/stores/dataStore';
import {TableModel, TableView} from 'src/core/ui/collections/table';
import {CommandResult} from '../../../../core/stores/types';
import {ProjectTemplatesStore, ProjectTemplateSummary} from '../../../../stores/templates-store';
import NewProjectTemplateView from './project-template-new';
import {UserProfileProps, withUserProfile} from "../../../../components/user-profile";

// tslint:disable-next-line:no-empty-interface
interface ProjectTemplateListViewProps extends RouteComponentProps<{ companyId: string }>, WithTranslation, UserProfileProps {
    companyId: string;
    companyName: string;
}

interface ProjectTemplateListViewState {
    query: Query;
    isCreationModalOpen: boolean,
    isBusy: boolean;

}

@connect(['projectTemplates', ProjectTemplatesStore])
class TaskTemplateListView extends React.Component<ProjectTemplateListViewProps, ProjectTemplateListViewState> {
    private get ProjectTemplateStore() {
        return (this.props as any).projectTemplates as ProjectTemplatesStore;
    }

    constructor(props: ProjectTemplateListViewProps) {
        super(props);
        this.state = {
            query: { searchQuery: '', orderBy: [{ field: 'title', direction: 'Ascending', useProfile: false }], skip: 0, take: 10 },
            isCreationModalOpen: false,
            isBusy: false,
        };
    }

    componentWillMount() {
        this.ProjectTemplateStore.changeUrl(this.props.companyId);
        this.load(this.state.query);
    }

    @autobind
    private load(query: Query) {
        this.ProjectTemplateStore.getAllAsync(query);
    }

    @autobind
    private isReadOnly() {
        return (this.props.userProfile && this.props.userProfile.roles &&
            (this.props.userProfile.roles.includes("CompanyDataViewer")
                && !(this.props.userProfile.roles.includes("Manager")
                    || this.props.userProfile.roles.includes("Administrator")
                    || this.props.userProfile.roles.includes("ClientAdmin")
                    || this.props.userProfile.roles.includes("FIConsultant"))));
    }

    @autobind
    private onQueryChanged(query: Query) {
        this.setState({ query }, () => this.load(query));
    }

    @autobind
    private async onDeleteRow(item: ProjectTemplateSummary, state: ItemState): Promise<CommandResult<any>> {
        return await this.ProjectTemplateStore.deleteAsync(`${item.id}`);
    }

    @autobind
    private onNewItem() {
        this.setState({ isCreationModalOpen: true });
    }
    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
                onClose: () => clearInterval(timer),
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }
    @autobind
    private async onSaveItem(item: ProjectTemplateSummary, state: ItemState) {
        const { t } = this.props as any;
        return await this.ProjectTemplateStore.saveAsync(`${item.id}`, item, state).finally(() => this.countDownNotification(notification.success, t("Notification"), t("All changes were successfully saved"), "succes")).catch(error => { this.countDownNotification(notification.error, t("Error"), t("There was an error saving changes"), "error") });
    }

    @autobind
    private onNewItemClosed(id: string | undefined) {
        this.setState({ isCreationModalOpen: false });
        this.load(this.state.query);
    }

    public render() {
        const { t } = this.props as any;
        let isReadOnly = this.isReadOnly()
        const tableModel = {
            query: this.state.query,
            columns: [
                {
                    sortable: true,
                    field: 'title',
                    title: t('Project Template Name'),
                    renderer: (data) => <span> {data.title} </span>,
                    editor: (data) => <Input />
                },
            ],
            data: this.ProjectTemplateStore.state,
            sortFields: [{
                field: 'title',
                text: t('Project Template Name'),
                useProfile: false
            }],
        } as TableModel<ProjectTemplateSummary>;

        return (
            <div>
                <Row type={'flex'} align='top' justify='space-between' >
                    <Col span={24} style={{ width: '100%' }}>
                        <Spin data-tut="reactour__navegateTemplate1" size='large' spinning={this.ProjectTemplateStore.state.isBusy}>
                            <TableView
                                showDeleteStatusWindow
                                rowKey='id'
                                model={tableModel}
                                error={this.ProjectTemplateStore.state.result && !this.ProjectTemplateStore.state.result.isSuccess && formatMessage(this.ProjectTemplateStore.state.result)}
                                embedded={false}
                                onQueryChanged={(q: Query) => this.onQueryChanged(q)}
                                onRefresh={() => this.load(this.state.query)}
                                canEdit={!isReadOnly}
                                canDelete={!isReadOnly}
                                onDeleteRow={this.onDeleteRow}
                                canCreateNew={!isReadOnly}
                                onNewItem={() => this.onNewItem()}
                                onSaveRow={this.onSaveItem}
                            >
                            </TableView>
                        </Spin>
                    </Col>
                </Row>
                {this.state.isCreationModalOpen &&
                    <NewProjectTemplateView
                        companyId={this.props.companyId}
                        onClose={this.onNewItemClosed}
                    />}
            </div>
        )
    }
}

// Wire up the React component to the Redux store
export default withUserProfile(withUserProfile(withTranslation()(withIdentity(withRouter(TaskTemplateListView)))));
